export function quotaVal(q, key, def) { if (!q || q[key] == null) return def; return q[key]; }
export const industryName = { assembly:'装配', welding:'焊接', qc:'质检', electronics:'电子' };
export function industryLabel(k) { return industryName[k] || k; }

export function tagClass(s) { const m={active:'tag-green',trial:'tag-blue',suspended:'tag-orange',deleted_pending:'tag-red',purged:'tag-gray'}; return m[s]||'tag-blue'; }
export function statusName(s) { const m={active:'已激活',trial:'试用中',suspended:'已暂停',deleted_pending:'待删除',purged:'已清除'}; return m[s]||s; }
